// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36uHq","clinicsSelect":"styles_clinicsSelect__tydEs"};